import { render, staticRenderFns } from "./tableZhiyeTaocan.vue?vue&type=template&id=3d020097"
import script from "./tableZhiyeTaocan.vue?vue&type=script&lang=js"
export * from "./tableZhiyeTaocan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports